import {Presenter} from '../../Support/with_presenter';
import {PreviewWorkout} from '../../Models/PreviewWorkout';
import {WorkoutsService} from '../../Network/WorkoutsService';
import {loadingResponse, NetworkRequestStatus, NetworkResult} from '../../Network/NetworkResult';
import {FullWorkout} from '../../Models/FullWorkout';
import {workoutTitleFormatter} from '../Support/workoutTitleFormatter';
import {GeoTrack} from '../../Models/GeoTrack';
import {WorkoutExecutionType} from '../../Models/WorkoutExecutionType';
import {TracksDownloadService} from '../../Network/TracksDownloadService';

export class WorkoutSharePresenter implements Presenter {
    public fullWorkoutResult: NetworkResult<FullWorkout> = loadingResponse();
    public geoTrackDownloadResult: NetworkResult<GeoTrack> = loadingResponse();

    public get title(): string | null {
        if (this.previewWorkout) {
            return workoutTitleFormatter(this.previewWorkout);
        }
        if (this.fullWorkoutResult.status === NetworkRequestStatus.Success) {
            return workoutTitleFormatter(this.fullWorkoutResult.data);
        }

        return null;
    }

    constructor(
        public id: number,
        public hash: string,
        public previewWorkout: PreviewWorkout | null,
        private workoutService: WorkoutsService,
        private tracksDownloadService: TracksDownloadService,
    ) {}

    public async mount(): Promise<void> {
        this.fullWorkoutResult = await this.workoutService.fullByHash(this.id, this.hash);
        if (
            this.fullWorkoutResult.status === NetworkRequestStatus.Success &&
            this.fullWorkoutResult.data.execution_type === WorkoutExecutionType.OUTDOOR
        ) {
            this.geoTrackDownloadResult = await this.tracksDownloadService.forGeoTrackUrl(
                this.fullWorkoutResult.data.track_geo_url,
            );
        }
    }

    public unmount(): void {
        /* Noop */
    }
}
